import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {PropertiesService} from '../../../../admin-services/properties.service';
import {first} from 'rxjs/operators';
import {AlertService} from '../../../../../services/alert.service';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { MatChipsModule } from '@angular/material/chips';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-preview-booking',
    templateUrl: './preview-booking.component.html',
    styleUrls: ['./preview-booking.component.scss'],
    standalone: true,
    imports: [NgIf, MatChipsModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule]
})
export class PreviewBookingComponent implements OnInit {

  @Input() public booking:any;
  @Input() public previewOnly:boolean=false;
  @Output() private needRefresh: EventEmitter<any> = new EventEmitter<any>();

  public form:UntypedFormGroup;
  public isSending:boolean=false;


  constructor(
    private modaleService:NgbModal,
    private fb:UntypedFormBuilder,
    private careService: PropertiesService,
    private alertService: AlertService,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      content:[this.booking.note],
    })
    this.setCoverPhoto();
  }

  public leaveNote(modale):void {
    this.modaleService.open(modale, {size:'sm', centered:true});
  }

  /**
   * Set la photo de couverture du booking
   * @private
   */
  private setCoverPhoto() {
    if (this.booking.property && this.booking.property.property_photos && this.booking.property.property_photos.length > 0) {
      const cover_photo = this.booking.property.property_photos.find(x => x.cover_photo == 1);
      if (cover_photo) {
        this.booking['cover_photo'] = cover_photo.photo;
      }
    }
  }

  public sendNote(): void {
    this.isSending = true;
    this.careService.addNoteToBooking({id: this.booking.id, note:this.form.value.content}).pipe(first()).subscribe((data: any) => {
      this.isSending = false;
      if (data.status == 'success') {
        this.needRefresh.emit(this.booking);
        this.modaleService.dismissAll();
        this.alertService.openSnackBar('Note mise à jour correctement', 'snack-success');
      } else {
        this.alertService.openSnackBar('Un problème est suvenu, la note n\'a pas pu être laissée', 'snack-error');
      }

    })
  }

}
